import React from 'react';
import $ from 'jquery';
import { userService } from '../../_services';
import moment, { relativeTimeRounding } from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import Calendar from '../../components/css/dark/img/date_icon.png';
import * as signalR from '@aspnet/signalr';

class CreateNotification extends React.Component {
    constructor(props) {
        super(props);
        var startdate = new Date();
        startdate.setDate(startdate.getDate() - 30);
        var enddate = new Date();
        if (localStorage.getItem('User_Start_Date') != "" && localStorage.getItem('User_Start_Date') != null && localStorage.getItem('User_Start_Date') != undefined) {
            startdate = localStorage.getItem('User_Start_Date');
        }
        if (localStorage.getItem('User_End_Date') != "" && localStorage.getItem('User_End_Date') != null && localStorage.getItem('User_End_Date') != undefined) {
            enddate = localStorage.getItem('User_End_Date');
        }
        this.state = {
            loader: false,
            disabled: false,
            userdata: JSON.parse(localStorage.getItem('user')),
            startDate: new moment(startdate).format("MM/DD/YYYY"),
            endDate: new moment(enddate).format("MM/DD/YYYY"),
            error: '',
            notConent: 'Notification Content here',
            dateTime: 'Select Date & Time',
            notifyError: '',
            dateTimeError: '',
            options: [
                { value: 'Broker' },
                { value: 'Admin' },
                { value: 'Sub Admin' },
                { value: 'Wholesaler' },
                { value: 'Distributor' },
                { value: 'All' },
                { value: 'Email Campaign' },
                { value: 'Mail Campaign' },
                { value: 'Web Campaign' },
                { value: 'Other' }
            ],
            selectValue: [],
            expanded: false,
            defaultOption: 'Broker',
            mhError: '',
            pickerDate: ''
        };
    }
    componentDidMount() {
        $('body').addClass('create-note');
        let bind = this;
        var checkboxes = document.getElementById("checkboxes");
        $(document).mouseup(function (e) {
            if ($(e.target).closest(".multiselect").length === 0) {
                checkboxes.style.display = "none";
                bind.setState({ expanded: false });
            }
        });
    }
    componentWillUnmount() {
        $('body').removeClass('create-note');
    }
    fetchDataLocally(UserType, UserEmail, FilterJson) {
        try {
            userService.GetNotification(UserType, UserEmail, FilterJson).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            this.setState({ notification: apidata, loader: false });
                        } else {
                            this.setState({ error: 'Error', loader: false });
                        }
                    }
                    catch (error) {
                        this.setState({ error: 'Error', loader: false });
                    }
                });
        }
        catch (error) {
        }
    }
    handleCalendar = (e, picker) => {
        try {
            if (Math.round((picker.startDate._d.getTime() - picker.oldEndDate._d.getTime()) / 1000) == 0) {
                let startDate = new moment(picker.startDate).format("YYYY-MM-DD");
                let startTime = new moment(picker.minDate).format(" HH:mm:ss");
                let changedStartDate = startDate + startTime;
                let converInGmt = new moment(changedStartDate).utc();
                this.setState({ dateTime: changedStartDate, pickerDate: converInGmt._d });
                $('.first-one .form-control').val(changedStartDate);
            } else {
                let changedStartDate = new moment(picker.startDate).format("YYYY-MM-DD HH:mm:ss");
                this.setState({ dateTime: changedStartDate, pickerDate: picker.startDate._d });
                $('.first-one .form-control').val(changedStartDate);
            }
        }
        catch (error) {
        }
    }
    schedule = () => {
        try {
            let notHeading = 'N/A';
            let notContent = this.state.notConent;
            let checkAll = this.state.selectValue.filter((user) => user == 'All');
            let usedFor;
            if (checkAll[0] == 'All') {
                usedFor = checkAll.join(',');
            } else {
                usedFor = this.state.selectValue.join(',');
            }
            let email = this.state.userdata.email;
            let userType = this.state.userdata.userrole;
            let startDate = new Date();
            let endDate = this.state.pickerDate;
            let timeSpan;
            if (endDate != '') {
                timeSpan = Math.round((startDate.getTime() - endDate.getTime()) / 1000);
            }
            let publishedOn = this.state.dateTime;
            var publish_utc_date = (new Date(Date.parse(publishedOn))).toUTCString();
            let count = 0;
            if (usedFor == '') {
                usedFor = 'Broker'
            }
            // message
            if (notContent == '' || notContent == null || notContent == undefined || notContent == "Notification Content here") {
                this.setState({ notifyError: 'Notification required', loader: false });
                count = count + 1;
            } else {
                if (notContent.length> 100) {
                    this.setState({ notifyError: 'Notification content exceeded 100 character limits', loader: false });
                    count = count + 1;
                }
            }
            // date and time
            if (publishedOn == '' || publishedOn == null || publishedOn == undefined || publishedOn == 'Select Date & Time') {
                this.setState({ dateTimeError: 'Date and time required', loader: false });
                count = count + 1;
            } else if (timeSpan >= 5) {
                this.setState({
                    dateTimeError: 'Schedule date & time must be equal or greater than current date & time', dateTime: 'Select Date & Time', loader: false });
                count = count + 1;
            }
            if (count == 0) {
                this.createNotification(notHeading, notContent, usedFor, email, userType, publish_utc_date);
                this.setState({ loader: true });
            }
        } catch (error) {
            this.setState({ error: 'Error', loader: false });
        }
    }
    createNotification(Not_Heading, Not_Content, UserFor, PublichedUserEmail, PublichedUserType, PublishedOn) {
        try {
            userService.SaveNotification(Not_Heading, Not_Content, UserFor, PublichedUserEmail, PublichedUserType, PublishedOn).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].statuscode == "1") {
                                this.setState({ error: apidata[0].statusmessage, loader: false });
                                setTimeout(() => {
                                    this.setState({ error: '', loader: false, notConent: 'Notification Content here', selectValue: [], dateTime: 'Select Date & Time' });
                                }, 4000);
                                try {
                                    var connection = new signalR.HubConnectionBuilder().withUrl("/notification", {
                                        skipNegotiation: true,
                                       transport: signalR.HttpTransportType.WebSockets
                                    }).build();
                                    connection.start().then(() => {
                                        connection.invoke("UpdateNotify", PublichedUserEmail, UserFor).catch(err => console.error(err.toString()));
                                    });
                                } catch (err) {
                                }
                            } else {
                                this.setState({ error: apidata[0].statusmessage, loader: false });
                                setTimeout(() => {
                                    this.setState({ error: '' });
                                }, 4000);
                            }
                        }
                        else {
                            this.setState({ error: 'Error, Please try again.', loader: false });
                        }
                    }
                    catch (error) {
                        this.setState({ error: 'Error, Please try again.', loader: false });
                    }
                });
        }
        catch (error) {
        }
    }
    notContent = () => {
        try {
            let NotContent = $('.notConent').val();
            this.setState({ notConent: NotContent, notifyError: '' });
        } catch (error) {
            this.setState({ error: 'Error', loader: false });
        }
    }
    closeNotification = () => {
        try {
            this.props.closeCreateNotification();
            this.props.OpenNotification(this.props.cPage);
        } catch (error) {
            this.setState({ error: 'Error', loader: false });
        }
    }
    handleFocus = () => {
        try {
            this.setState({ dateTimeError: '' });
        } catch (error) {
            this.setState({ error: 'Error', loader: false });
        }
    }
    showCheckboxes = () => {
        try {
            var checkboxes = document.getElementById("checkboxes");
            if (!this.state.expanded) {
                checkboxes.style.display = "block";
                this.setState({ expanded: true });
            } else {
                checkboxes.style.display = "none";
                this.setState({ expanded: false });
            }
        } catch (error) {
        }
    }
    handleSelect = (e) => {
        try {
            $(e.target).toggleClass('active');
            let selected = e.target.getAttribute('value');
            let sValue = this.state.selectValue;
            if ($(e.target).hasClass('active')) {
                sValue.push(selected);
            } else {
                sValue = sValue.filter(function (item) {
                    return item !== selected
                })
            }
            if (sValue.length > 6) {
                $(e.target).parents().eq(2).addClass('change-maxwidth');
            } else {
                $(e.target).parents().eq(2).removeClass('change-maxwidth');
            }
            this.setState({ selectValue: sValue });
            e.stopPropagation();
            e.preventDefault();
            return false;
        } catch (error) {
        }
    }
    handleMessage = () => {
        try {
            if (this.state.notConent == 'Notification Content here') {
                this.setState({ notConent: '' });
            }
        } catch (error) {}
    }
    handleBlur = () => {
        try {
            if (this.state.notConent == '') {
                this.setState({ notConent: 'Notification Content here' });
            }
        } catch (error) { }
    }
    render() {
        const { loader, selectValue, defaultOption, options, mhError, notConent, notifyError, dateTimeError, error} = this.state;
        return (
            <div>
                <div className='popup manage-scroll manage-distributor-design new-notification'>
                    <div className='popup_inner'>
                        <h1>{this.props.text}<button onClick={this.closeNotification}>X</button></h1>
                        {
                            loader ? (<div className="theme-loader"></div>) : null
                        }
                        <div className="WhCommissionPopup">
                            <form autoComplete="off" onSubmit={e => { e.preventDefault() }}>
                                <div className="selectSection payout">
                                    <div className="same-on upcomingDate-popup">
                                        <div className="multiselect">
                                            <div class="selectBox" onClick={this.showCheckboxes}>
                                                <span className="down-arrow"></span>
                                                <select className={ selectValue.length == 0 ? '' : "hide-element"}>
                                                    <option hidden>{ defaultOption}</option>
                                                </select>
                                                <div className="overSelect">
                                                    <div className="selectOver">
                                                        {
                                                            selectValue.map((item, itemIndex) => {
                                                                return <span>{item}</span>
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="checkboxes">
                                                {
                                                    options.map((item) => {
                                                        return <label value={item.value} onClick={this.handleSelect}><input type="checkbox" />{item.value}</label>
                                                    })
                                                }
                                            </div>
                                        </div>
                                        {
                                            mhError &&
                                            <div className={'alert alert-danger'}>{mhError}</div>
                                        }
                                    </div>
                                </div>
                                <textarea className="form-Control notConent" value={notConent} onBlur={this.handleBlur} onFocus={this.handleMessage} onChange={this.notContent}></textarea>
                                { notifyError &&
                                    <div className={'alert alert-danger less delete'}>{notifyError}</div>
                                }

                                <DateRangePicker 
                                    initialSettings={{
                                        singleDatePicker: true,
                                        timePicker: true,
                                        timePicker24Hour: false,
                                        timePickerIncrement: 1,
                                        minDate: moment().toDate(),
                                        showDropdowns: false,
                                        autoUpdateInput: false,
                                        locale: {
                                            format: 'YYYY-MM-DD hh:mm:ss A'
                                        }
                                    }}
                                    onApply={this.handleCalendar}
                                >
                                    <div className="react-bootstrap-daterangepicker-container">
                                        <div className="react-datepicker_input-container first-one">
                                            <img className="date-time" src={Calendar} alt="Date and time" />
                                            <input type="text" className="form-control first readonly-attr" value={this.state.dateTime} onFocus={this.handleFocus} />
                                        </div>
                                    </div>
                                </DateRangePicker>
                                { dateTimeError &&
                                    <div className={'alert alert-danger less delete'}>{ dateTimeError}</div>
                                }
                                <div className="clearfix"></div>
                                <div className="pop-btn ungap">
                                    <button className="btn" onClick={this.schedule}>Schedule Notification</button>
                                </div>

                            </form>
                            {
                                error &&
                                <div className={'alert alert-danger delete'}>{ error}</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default CreateNotification;